import { ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';
import { ClearButton } from '@morressier/alembic';
import '../styles.css';

interface NestedTabListProps {
  children: ReactNode;
  width?: string;
}

interface NestedTabListSubComponentProps {
  children: ReactNode;
}

const NestedTabList: React.FC<NestedTabListProps> & {
  Navigation: React.FC<NestedTabListSubComponentProps>;
  Tab: React.FC<
    NestedTabListSubComponentProps & { isActive: boolean; onClick: () => void }
  >;
} = ({ children }) => {
  return (
    <Flex
      backgroundColor="surfaceSecondaryFill"
      flexDirection="column"
    >
      {children}
    </Flex>
  );
};

NestedTabList.Navigation = ({ children }) => {
  return (
    <Flex
      paddingRight={8}
      height={16}
      alignItems="center"
      borderBottomWidth="1px"
      borderColor="neutralPrimaryBorder"
      borderStyle="solid"
    >
      {children}
    </Flex>
  );
};

NestedTabList.Tab = ({ children, isActive, onClick }) => {
  return (
    <Flex
      paddingX={4}
      borderBottomWidth="2px"
      borderStyle="solid"
      justifyContent="center"
      alignItems="center"
      height="100%"
      className={`tab-flex-container ${isActive ? 'is-active' : ''}`}
    >
      <ClearButton
        height="100%"
        ariaLabel={`${children} tab`}
        onClick={onClick}
        textTransform="capitalize"
      >
        {children}
      </ClearButton>
    </Flex>
  );
};

export default NestedTabList;
